import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { ActiveTripComponent } from './components/active-trip/active-trip.component';
import { ThrowLinesComponent } from './components/throw-lines/throw-lines.component';
import { TripDetailsComponent } from './components/trip-details/trip-details.component';
import { VisibilitySettingsComponent } from './components/visibility-settings/visibility-settings.component';
import { InviteAMateComponent } from './components/invite-a-mate/invite-a-mate.component';
import { TripService } from '../../services/trip.service';
import { ClarityService } from '../../services/clarity.service';

@Component({
  selector: 'app-trip',
  standalone: true,
  imports: [CommonModule, ActiveTripComponent, ThrowLinesComponent, TripDetailsComponent, VisibilitySettingsComponent, InviteAMateComponent],
  templateUrl: './trip.component.html',
  styleUrl: './trip.component.scss'
})
export class TripComponent implements OnInit, OnDestroy {
  showThrowLines = false; // Initial trigger
  isTripActive = false;
  showTripDetails = false;
  showVisibilitySettings = false;
  showInviteMate = false;
  currentTripId: string = '';
  /** Real trip start (ms epoch) so the card's timer matches the app's. */
  tripStartTimeMs: number | null = null;

  private sub?: Subscription;

  constructor(private tripService: TripService, private clarityService: ClarityService) {}

  ngOnInit() {
    // Track the id reactively rather than reading it once: a trip started on the phone
    // is only discovered after the trips list loads (home-page adopts it), which
    // happens well after this component initialises. Reading once meant the captain
    // never got a status card for a trip they'd started in the app.
    this.sub = this.tripService.currentTripId$.subscribe((tripId) => {
      this.currentTripId = tripId || '';
      this.isTripActive = !!this.currentTripId;
      this.tripStartTimeMs = this.currentTripId ? this.tripService.getCurrentTripStartTime() : null;
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  // Method to be called from parent (Home Page)
  openThrowLinesModal() {
    this.showThrowLines = true;
  }

  onThrowLinesClosed() {
    this.showThrowLines = false;
  }

  onStartTrip(tripId: string) {
    this.showThrowLines = false;
    this.isTripActive = true;
    this.currentTripId = tripId;
    this.tripService.setCurrentTripStartTime(Date.now());
    this.tripService.setCurrentTripId(tripId);
    this.clarityService.trackEvent('trip_started');
    this.clarityService.setAction('action_start_trip');
    this.clarityService.setTripState(true, 'active');
  }

  onViewDetails() {
    this.showTripDetails = true;
  }

  onDetailsClosed() {
    this.showTripDetails = false;
  }

  onOpenVisibilitySettings() {
    this.showVisibilitySettings = true;
  }

  onVisibilitySettingsClosed() {
    this.showVisibilitySettings = false;
  }

  onOpenInviteMate() {
    this.showInviteMate = true;
  }

  onInviteMateClosed() {
    this.showInviteMate = false;
  }

  onTripEnded() {
    this.isTripActive = false;
    this.currentTripId = '';
    this.tripService.setCurrentTripStartTime(null);
    this.tripService.setCurrentTripId('');
    this.clarityService.trackEvent('trip_ended');
    this.clarityService.setAction('action_end_trip');
    this.clarityService.setTripState(false, 'ended');
  }
}
